<app-auth-layout>
  <form
    class="form-container"
    [class.fade]="isTransitioning"
    [formGroup]="signUpForm"
    (ngSubmit)="step() === steps.Welcome ? goToNextStep(isSso ? steps.Consent : steps.Pincode) : null"
  >
    @if (step() === steps.Welcome) {
      <div class="title-container">
        <h1 class="title">{{ 'WebApp.v1.Auth.SignUp.Welcome.Unknown.Title' | translate }}</h1>
        <p class="sub-title">{{ 'WebApp.v1.Auth.SignUp.Welcome.Unknown.SubTitle' | translate : { CompanyName: companyName() } }}</p>
      </div>

      <app-button class="button" [label]="'WebApp.v1.Shared.Buttons.GetStarted' | translate"></app-button>
    }

    @if (step() === steps.Pincode) {
      <div class="title-container code">
        <h1 class="title">{{ 'WebApp.v1.Auth.SignUp.Pincode.SetYourPincode' | translate }}</h1>
        <p class="sub-title">{{ 'WebApp.v1.Auth.SignUp.Pincode.SubTitle' | translate }}</p>
      </div>

      <div class="error">
        {{ errorMessage ? (errorMessage | translate) : '' }}
      </div>

      <app-pin-code class="pin-code" (pinChanged)="updatePincode($event)"></app-pin-code>
    }

    @if (step() === steps.ConfirmPincode) {
      <div class="title-container code">
        <h1 class="title">{{ 'WebApp.v1.Auth.SignUp.ConfirmPincode.Title' | translate }}</h1>
        <p class="sub-title">{{ 'WebApp.v1.Auth.SignUp.ConfirmPincode.SubTitle' | translate }}</p>
      </div>

      <div class="error">
        {{ errorMessage ? (errorMessage | translate) : '' }}
      </div>

      <app-pin-code class="pin-code" (pinChanged)="updatePincode($event)"></app-pin-code>

      <div class="actions">
        <div class="back" (click)="goToPincode()">
          <i class="fa-solid fa-chevron-left"></i>{{ 'WebApp.v1.Shared.Buttons.Back' | translate }}
        </div>
      </div>
    }

    @if (step() === steps.Consent) {
      <div class="title-container">
        <h1 class="title">{{ 'WebApp.v1.Auth.SignUp.Consent.Title' | translate }}</h1>
        <p class="sub-title">{{ 'WebApp.v1.Auth.SignUp.Consent.SubTitle' | translate }}</p>
      </div>

      <div class="consent-container">
        <p class="text" [innerHTML]="terms"></p>
      </div>
      <app-button
        class="button"
        [label]="'WebApp.v1.Shared.Buttons.Accept' | translate"
        (click)="goToNextStep(steps.PersonalDetails)"
      ></app-button>
    }

    @if (step() === steps.PersonalDetails) {
      <div class="title-container code">
        <h1 class="title">{{ 'WebApp.v1.Auth.SignUp.Welcome.Unknown.PersonalInfo' | translate }}</h1>
        <p class="sub-title">{{ 'WebApp.v1.Auth.SignUp.Welcome.Unknown.PersonalInfo.SubTitle' | translate }}</p>
      </div>

      <div class="error">{{ signUpValidationError() | translate }}</div>

      <div class="input-container personal-details-input-container">
        <div class="row">
          <input
            class="input"
            formControlName="firstname"
            placeholder="{{ 'WebApp.v1.Auth.SignUp.PersonalDetails.Form.FirstName' | translate }}"
          >
          <input
            class="input"
            formControlName="lastname"
            placeholder="{{ 'WebApp.v1.Auth.SignUp.PersonalDetails.Form.LastName' | translate }}"
          >
        </div>
        <div class="row">
          <input
            class="input"
            formControlName="email"
            placeholder="{{ 'WebApp.v1.Auth.SignUp.PersonalDetails.Form.Email' | translate }}"
          >
        </div>
        <div class="row phone">
            <app-phone-input formControlName="phone" (dropdownOpenChange)="dropdownOpen = $event"></app-phone-input>
        </div>
        @if (showZipCode || showHomeCity) {
          <div class="row">
            @if (showZipCode) {
              <input
                class="input"
                formControlName="zipCode"
                placeholder="{{ 'WebApp.v1.Auth.SignUp.PersonalDetails.Form.ZipCode' | translate }}"
              >
            }
            @if (showHomeCity) {
              <input
                class="input"
                formControlName="homeCity"
                placeholder="{{ 'WebApp.v1.Auth.SignUp.PersonalDetails.Form.HomeCity' | translate }}"
              >
            }
          </div>
        }
        @if (showAddress || showBirthday) {
          <div class="row">
            @if (showAddress) {
              <input
                class="input"
                formControlName="homeAddress"
                placeholder="{{ 'WebApp.v1.Auth.SignUp.PersonalDetails.Form.HomeAddress' | translate }}"
              >
            }
            @if (showBirthday) {
              <input
                class="input"
                formControlName="birthday"
                type="date"
                placeholder="{{ 'WebApp.v1.Auth.SignUp.PersonalDetails.Form.Birthday' | translate }}"
              >
            }
          </div>
        }

        <div class="row">
          @if (!isCompanySpecific) {
            <input
              class="input"
              formControlName="company"
              placeholder="{{ 'WebApp.v1.Auth.SignUp.PersonalDetails.Form.Company' | translate }}"
            >
            <input
              class="input"
              formControlName="department"
              placeholder="{{ 'WebApp.v1.Auth.SignUp.PersonalDetails.Form.Department' | translate }}"
            >
          }

          @if (showDepartmentDropdown) {
            <div
              class="department-select"
              [class.open]="departmentDropdownOpen"
              (click)="$event.stopPropagation()"
            >
              <button
                class="input department-select-trigger"
                type="button"
                (click)="toggleDepartmentDropdown()"
              >
                <span>{{ selectedDepartmentLabel | translate }}</span>
                <span class="department-select-arrow"></span>
              </button>
            </div>
          }
        </div>
      </div>

      @if (departmentDropdownOpen) {
        <div
          class="department-options department-options-floating"
          (click)="$event.stopPropagation()"
        >
          @for (department of departmentDropdownOptions; track department) {
            <button
              class="department-option"
              type="button"
              [class.selected]="signUpForm.get('department')?.value === department"
              (click)="selectDepartment(department)"
            >
              {{ department }}
            </button>
          }
        </div>
      }

      <app-button
        class="button"
        [class.hidden]="dropdownOpen"
        [label]="'WebApp.v1.Shared.Buttons.Complete' | translate"
        (click)="completeSignup()"
      ></app-button>
    }

    @if (step() === steps.SsoLinking) {
      <div class="title-container">
        <h1 class="title">{{ 'WebApp.v1.Auth.Login.LinkingAccount.Title' | translate }}</h1>
        <p class="sub-title">{{ 'WebApp.v1.Auth.Login.LinkingAccount.Security.Text' | translate: { companyName: companyName() } }}</p>
        <p class="sub-title margin">{{ 'WebApp.v1.Auth.Login.LinkingAccount.Continue.Text' | translate: { companyName: companyName() } }}</p>
      </div>

      <app-button class="button" [label]="'WebApp.v1.Shared.Buttons.Continue' | translate" (click)="continueToSsoPage()"></app-button>
    }
  </form>
</app-auth-layout>
